import { PlatformInstagramColorIcon } from 'ui-components/dist/PlatformInstagramColorIcon';
import { PlatformSnapchatColorIcon } from 'ui-components/dist/PlatformSnapchatColorIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';
import { SOCIAL_PLATFORM_PIPELINE_STATUS } from '~/clientApi/offPlatform.model';
import {
  ALL_SOCIAL_PLATFORM_TYPE,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS,
} from '~/constants';
import { PlatformSearchResult } from '~/hooks/api/useOPCreatorSearch';

import { routes } from '../router';

export const getInstagramProfileUrl = (handle: string): string =>
  `https://www.instagram.com/${handle}`;

export const getTiktokProfileUrl = (handle: string): string =>
  `https://www.tiktok.com/@${handle}`;

export const getYoutubeChannelUrl = (channelSlug: string): string =>
  `https://www.youtube.com/@${channelSlug}`;

export const getSnapchatProfileUrl = (handle: string): string =>
  `https://www.snapchat.com/add/${handle}`;

export const formatInstagramHandle = (handle: string): string => `@${handle}`;
export const formatTikTokHandle = (handle: string): string => `@${handle}`;
export const formatYouTubeHandle = (handle: string): string => handle;

export const getPlatformProfileLink = (
  platform: ALL_SOCIAL_PLATFORM_TYPE,
  handle: string,
) => {
  const method = {
    [SOCIAL_PLATFORMS.instagram]: getInstagramProfileUrl,
    [SOCIAL_PLATFORMS.tiktok]: getTiktokProfileUrl,
    [SOCIAL_PLATFORMS.youtube]: getYoutubeChannelUrl,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: getSnapchatProfileUrl,
  }[platform];
  return method ? method(handle) : undefined;
};

export const getPlatformIcon = (platform: SOCIAL_PLATFORMS) => {
  const icon = {
    [SOCIAL_PLATFORMS.instagram]: PlatformInstagramColorIcon,
    [SOCIAL_PLATFORMS.tiktok]: PlatformTikTokColorIcon,
    [SOCIAL_PLATFORMS.youtube]: PlatformYouTubeColorIcon,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: PlatformSnapchatColorIcon,
  };
  return icon[platform];
};

export const getPlatformFollowersText = (platform: SOCIAL_PLATFORMS) =>
  ({
    [SOCIAL_PLATFORMS.instagram]: 'followers',
    [SOCIAL_PLATFORMS.tiktok]: 'followers',
    [SOCIAL_PLATFORMS.youtube]: 'subscribers',
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: 'followers',
  })[platform];

export const formatPlatformHandle = (
  platform: SOCIAL_PLATFORMS,
  handle: string,
) => {
  const method = {
    [SOCIAL_PLATFORMS.instagram]: formatInstagramHandle,
    [SOCIAL_PLATFORMS.tiktok]: formatTikTokHandle,
    [SOCIAL_PLATFORMS.youtube]: formatYouTubeHandle,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: formatInstagramHandle,
  }[platform];
  return method ? method(handle) : undefined;
};

export const getPlatformLiveContentUrl = (contentId: string) => {
  return `${routes.contentSearch}?contentId=${contentId}`;
};

export const getHasPending = (_platforms: PlatformSearchResult) => {
  const platforms = Object.values(_platforms);
  const hasPending = platforms.some(
    (p) => p.pipelineStatus === SOCIAL_PLATFORM_PIPELINE_STATUS.pending,
  );

  return hasPending;
};
